module.exports = __webpack_public_path__ + "static/media/giphy.e800c846.gif";